import React from 'react';
import { CTAButton } from './CTAButton';
import { CHECKOUT_URL, HERO_IMAGE, offerIncludes } from '../data/product';
export function Offer() {
  return <section id="offer" className="scroll-mt-2 bg-navy px-4 py-4 sm:py-6" data-id="element-105" data-mp="17wjr2ld11p3u">
      <div className="mx-auto max-w-3xl rounded-lg border-2 border-volt bg-navy2 p-3 shadow-2xl sm:p-5" data-id="element-106" data-mp="1mm7jex38ddff">
        <p className="text-center font-head text-[12px] font-bold uppercase tracking-[0.2em] text-volt sm:text-sm" data-id="element-107" data-mp="1hoxtlgbxizr2">
          SPECIAL LAUNCH OFFER
        </p>
        <h2 className="mt-0.5 text-center text-xl leading-tight text-white sm:text-3xl" data-id="element-108" data-mp="p0a1b0srja40">
          🔧 INDUSTRIAL MAINTENANCE DIAGNOSTIC PRO™
        </h2>
        <p className="mt-1 text-center text-[13px] font-semibold uppercase leading-snug text-white/85 sm:text-[15px]" data-id="element-109" data-mp="13uy58aiim0hi">
          THE COMPLETE VISUAL TROUBLESHOOTING SYSTEM FOR INDUSTRIAL MAINTENANCE
          TECHNICIANS
        </p>

        <div className="mt-2 grid items-center gap-2 sm:grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)]" data-id="element-110" data-mp="2add53svuqzxn">
          <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" data-id="element-111" data-mp="pkqmk69sdn86">
            <img src={HERO_IMAGE} alt="INDUSTRIAL MAINTENANCE DIAGNOSTIC PRO complete 6-in-1 system" loading="lazy" className="mx-auto w-full max-w-[220px] sm:max-w-none" data-id="element-112" data-mp="pmlc5xw063il" />
          </a>
          <div data-id="element-113" data-mp="13ip0jak73hn5">
            <p className="font-head text-base font-bold uppercase tracking-wide text-volt" data-id="element-114" data-mp="13j74yuh0h265">
              Complete 6-in-1 System
            </p>
            <ul className="mt-1 grid gap-0.5" data-id="element-115" data-mp="bskgxe49eymz">
              {offerIncludes.map(item => <li key={item} className="text-[13px] font-semibold leading-snug text-white" data-id="element-116" data-mp="funwoexyope2">
                  <span className="text-volt" data-id="element-117" data-mp="kmp51ps0dvyt">✅</span> {item}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mt-2 text-center font-head text-base font-bold uppercase leading-tight text-white sm:text-xl" data-id="element-118" data-mp="3oa7jow81hbko">
          🔥 GET INDUSTRIAL MAINTENANCE DIAGNOSTIC PRO™ TODAY
        </p>
        <p className="text-center font-display text-4xl leading-none text-volt sm:text-6xl" data-id="element-119" data-mp="vde6j0j6zu3j">
          $26.90
        </p>

        <CTAButton href={CHECKOUT_URL} external className="mx-auto mt-1.5 max-w-md" data-id="element-120" data-mp="15620lnisfjyk">
          🔧 GET INSTANT ACCESS
        </CTAButton>

        <p className="mt-1 text-center text-[12px] font-semibold text-white/85" data-id="element-121" data-mp="108tjlq9dllyw">
          Immediate Digital Access
        </p>
        <p className="mt-0.5 text-center text-[12px] font-semibold text-volt" data-id="element-122" data-mp="7ibj8x01dyp6">
          🛡️ 7-Day Money-Back Guarantee
        </p>
      </div>
    </section>;
}